'use client';

import { MaterialSymbol } from '@florencelabs/icons';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useAnalytics } from '@provider-directory/components/analytics/analytics-provider';
import { useOrgContext } from '@provider-directory/components/org-context/org-context-provider';
import { getAvailablePhoneNumber } from '@provider-directory/functions/get-available-phone';
import {
  getLocationDisplayInfo,
  getMapsLinkByName,
} from '@provider-directory/functions/location';
import {
  ProviderDetailsResource,
  ProviderLocationResource,
} from '@provider-directory/types/providers.contracts';

export const GetDirectionsLink = ({
  provider,
  primaryLocation,
}: {
  provider: ProviderDetailsResource;
  primaryLocation: ProviderLocationResource;
}): ReactElement => {
  const analytics = useAnalytics();
  const orgContext = useOrgContext();
  const [t] = useTranslation();
  const { displayName, addressLabel } = getLocationDisplayInfo(primaryLocation);
  const phoneNumber = getAvailablePhoneNumber(
    primaryLocation,
    provider,
    orgContext.getAssociationPhoneSelection(),
  );

  return (
    <a
      onClick={(e) => {
        e.preventDefault();
        analytics.directionsEvent({
          provider,
          phoneNumber,
          linkContextPage: 'ProviderDetails',
          linkContextComponent: 'ProviderHeader',
          clickText: t('details.directions'),
          clickURL: e.currentTarget.href,
        });
        window.open(e.currentTarget.href);
      }}
      href={getMapsLinkByName(primaryLocation)}
      rel={'noopener noreferrer'}
      target={'_blank'}
      aria-label={t('aria.getDirectionsTo', {
        locationName: displayName,
        address: addressLabel,
      })}
      className={'flex flex-row items-center gap-2 text-primary-color'}
    >
      <div className={'text-body-medium-semibold leading-[140%]'}>
        {t('details.directions')}
      </div>
      <MaterialSymbol name={'north_east'} size={20} aria-hidden={'true'} />
    </a>
  );
};
